import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, vModelText as _vModelText, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex items-center justify-between border-b border-blue-800 pb-2" }
const _hoisted_2 = { class: "text-xl font-bold text-blue-900" }
const _hoisted_3 = { class: "flex justify-end operation" }
const _hoisted_4 = { class: "mb-4" }
const _hoisted_5 = { class: "block mb-1 font-medium" }
const _hoisted_6 = ["placeholder"]
const _hoisted_7 = {
  key: 0,
  class: "text-red-400 text-sm"
}
const _hoisted_8 = { class: "mb-4" }
const _hoisted_9 = { class: "block mb-1 font-medium" }
const _hoisted_10 = ["placeholder"]
const _hoisted_11 = {
  key: 0,
  class: "text-red-400 text-sm"
}
const _hoisted_12 = { class: "mb-4" }
const _hoisted_13 = { class: "block mb-1 font-medium" }
const _hoisted_14 = {
  key: 0,
  class: "text-red-400 text-sm"
}
const _hoisted_15 = { class: "mb-4" }
const _hoisted_16 = { class: "block mb-1 font-medium" }
const _hoisted_17 = ["placeholder"]
const _hoisted_18 = { class: "mb-4" }
const _hoisted_19 = { class: "block mb-1 font-medium" }
const _hoisted_20 = ["placeholder"]

import { reactive, watch, ref } from "vue";
import * as yup from "yup";

import AntModal from "@/components/container/AntModal.vue";
import { IVocabulary } from "@/models/IIearnEnglish";
import { fileToBase64 } from "@/utils/global";
import { createVocabulary } from "@/api/vocabularyApi";
import { message } from "ant-design-vue";
import { translate } from "@/utils/global";
import { getLoadingPost } from "@/utils/loadingUtils";
import { StarFilled, StarOutlined } from "@ant-design/icons-vue";
import i18n from "@/services/i18n";


export default /*@__PURE__*/_defineComponent({
  __name: 'ModalVocabularyAdd',
  props: {
  modelValue: {
    type: Boolean,
    required: true,
  },
},
  emits: ["update:modelValue", "closenoload"],
  setup(__props, { emit: __emit }) {

const props = __props;
const emit = __emit;
const form = reactive({
  english: "",
  translate: "",
  image: null as File | null,
  example_sentence: "",
  tags: "",
  notes: "",
  is_special: false,
});
const errors: { [key: string]: string } = reactive({
  english: "",
  translate: "",
  image: "",
});
const schema = yup.object().shape({
  english: yup.string().required("Word is required"),
  translate: yup.string().required("Translation is required"),
  image: yup
    .mixed()
    .nullable()
    .test(
      "fileSize",
      "File is too large (max 2MB)",
      (value) => !value || (value instanceof File && value.size <= 2097152)
    ),
});

const show = reactive({
  value: false,
});
const englishFieldref = ref<HTMLInputElement | null>(null);

watch(
  () => props.modelValue,
  (newValue) => {
    show.value = newValue;
  }
);

// Handle form submission
const handleSubmit = async () => {
  Object.keys(errors).forEach((key) => {
    errors[key] = "";
  });
  try {
    await schema.validate(form, { abortEarly: false });
    const vocabularyNew: IVocabulary = {
      english: form.english.trim(),
      translate: form.translate.trim(),
      image: form.image ? await fileToBase64(form.image as File) : undefined,
      example_sentence: form.example_sentence.trim(),
      is_special: form.is_special,
      tags: form.tags,
      notes: form.notes,
    };
    if (vocabularyNew.english && vocabularyNew.translate) {
      await createVocabulary(vocabularyNew);
    } else {
      throw new Error("Required vocabulary data is missing");
    }
    message.success(translate("message.success"));
    closeModal_Load();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (validationErrors: any) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if (validationErrors?.inner) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      validationErrors.inner.forEach((err: any) => {
        errors[err.path] = err.message;
      });
    } else {
      console.error(
        "Validation errors structure is incorrect or there were no errors."
      );
    }
  }
};
const handleFileUpload = (event: Event) => {
  const file = (event.target as HTMLInputElement).files?.[0];
  form.image = file || null;
};
const closeModal_Load = () => {
  emit("update:modelValue", false);
};
const closeModal_noLoad = () => {
  emit("closenoload", false);
};

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createBlock(AntModal, {
    visible: show,
    onCancel: closeModal_noLoad
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h2", _hoisted_2, _toDisplayString(_unref(i18n).global.t("vocabulary.add_new")), 1)
      ]),
      _createElementVNode("form", {
        onSubmit: _withModifiers(handleSubmit, ["prevent"])
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (form.is_special = !form.is_special)),
            class: "mt-2"
          }, [
            _withDirectives(_createVNode(_unref(StarFilled), { class: "text-yellow-300 text-2xl flex items-center transition-colors duration-500 hover:text-yellow-200" }, null, 512), [
              [_vShow, form.is_special]
            ]),
            _withDirectives(_createVNode(_unref(StarOutlined), { class: "text-gray-300 text-2xl flex items-center transition-colors duration-500 hover:text-gray-500" }, null, 512), [
              [_vShow, !form.is_special]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("label", _hoisted_5, _toDisplayString(_unref(i18n).global.t("vocabulary.word")), 1),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.english) = $event)),
            placeholder: _unref(i18n).global.t('vocabulary.word_placeholder'),
            class: "w-full px-0 py-2 dashed-border text-black rounded-sm focus:outline-none focus:ring-0 focus:ring-blue-900",
            ref_key: "englishFieldref",
            ref: englishFieldref
          }, null, 8, _hoisted_6), [
            [_vModelText, form.english]
          ]),
          (errors.english)
            ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(errors.english), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("label", _hoisted_9, _toDisplayString(_unref(i18n).global.t("vocabulary.translate")), 1),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.translate) = $event)),
            placeholder: _unref(i18n).global.t('vocabulary.translate_placeholder'),
            class: "w-full px-0 py-2 dashed-border text-black rounded-sm focus:outline-none focus:ring-0 focus:ring-blue-900"
          }, null, 8, _hoisted_10), [
            [_vModelText, form.translate]
          ]),
          (errors.translate)
            ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(errors.translate), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("label", _hoisted_13, _toDisplayString(_unref(i18n).global.t("image.image")) + " " + _toDisplayString(_unref(i18n).global.t("image.optional")), 1),
          _createElementVNode("input", {
            type: "file",
            onChange: handleFileUpload,
            accept: "image/*",
            class: "w-full px-0 py-2 dashed-border text-black rounded-sm focus:outline-none focus:ring-0 focus:ring-blue-900"
          }, null, 32),
          (errors.image)
            ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(errors.image), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("label", _hoisted_16, _toDisplayString(_unref(i18n).global.t("vocabulary.notes")), 1),
          _withDirectives(_createElementVNode("textarea", {
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.notes) = $event)),
            placeholder: _unref(i18n).global.t('vocabulary.notes_enter'),
            class: "w-full px-0 py-2 dashed-border text-black rounded-sm focus:outline-none focus:ring-0 focus:ring-blue-900",
            rows: "4"
          }, null, 8, _hoisted_17), [
            [_vModelText, form.notes]
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("label", _hoisted_19, _toDisplayString(_unref(i18n).global.t("vocabulary.example_sentence")), 1),
          _withDirectives(_createElementVNode("textarea", {
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.example_sentence) = $event)),
            placeholder: _unref(i18n).global.t('vocabulary.example_sentence_enter'),
            class: "w-full px-0 py-2 dashed-border text-black rounded-sm focus:outline-none focus:ring-0 focus:ring-blue-900",
            rows: "4"
          }, null, 8, _hoisted_20), [
            [_vModelText, form.example_sentence]
          ])
        ]),
        _createVNode(_component_a_button, {
          type: "primary",
          onClick: handleSubmit,
          class: "w-full h-12 rounded-sm bg-blue-900 hover:bg-gray-200 border-none focus:border-none focus:outline-none focus:ring-0 focus:shadow-none focus:bg-blue-700",
          loading: _unref(getLoadingPost)()
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(i18n).global.t("btn.add")), 1)
          ]),
          _: 1
        }, 8, ["loading"])
      ], 32)
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})